import Layout from '../../UI/Layout/Layout'
import Container from '../../UI/Container/Container'
import BackToCube from '../../UI/BackToCube/BackToCube'
import LeadForm from '../../UI/LeadForm/LeadForm'

const NewsAlarm: React.FC<{}> = () => {
  return (
    <Layout headerTransparent disableHeaderPadding disableAbsoluteFooter>
      <Container className="py-5">
        <BackToCube />
        <div className="mt-10">
          <LeadForm />
        </div>
      </Container>
    </Layout>
  )
}

export default NewsAlarm
